import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import * as fileSaver from 'file-saver';
import { FilterSolicitudAmpliacionSsoModel } from 'src/app/models/calendario-sso/FilterSolicitudAmpliacionSsoModel';
import { SolicitudAmpliacionAprobacionModel, SolicitudesAmpliacionAprobacionModel } from 'src/app/models/calendario-sso/ISolicitudAmpliacionAprobacionModel';
import { SolicitudAmpliacionSsoModel } from 'src/app/models/calendario-sso/SolicitudAmpliacionSsoModel';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterSolicitudAmpliacionSsoModel } from 'src/app/models/interfaces/calendario-sso/IFilterSolicitudAmpliacionSsoModel';
import { ISolicitudAmpliacionAprobacionModel } from 'src/app/models/interfaces/calendario-sso/ISolicitudAmpliacionAprobacionModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { CalendarioSsoService } from 'src/app/services/calendario-sso/calendario-sso.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { SolicitudAmpliacionSsoService } from 'src/app/services/solicitud-ampliacion-sso/solicitud-ampliacion-sso.service';
import { SsoAmpliacionAprobacionDialogComponent } from '../sso-ampliacion-aprobacion-dialog/sso-ampliacion-aprobacion-dialog.component';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  templateUrl: './sso-ampliacion-bandeja-aprobacion.component.html',
  styleUrls: ['./sso-ampliacion-bandeja-aprobacion.component.css']
})
export class SsoAmpliacionBandejaAprobacionComponent implements OnInit {
  
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  listaTipos: ParametroModel[] = new Array<ParametroModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  resultsLength = 0;
  currentPage = 0;
  model: IFilterSolicitudAmpliacionSsoModel = new FilterSolicitudAmpliacionSsoModel();
  displayedColumns: string[] = ['anio', 'mes', 'sede', 'empresa', 'tipo', 'fechaCreacion', 'solicitante','aprobado','desaprobado'];
  listaSolicitudes: SolicitudAmpliacionSsoModel[] = new Array<SolicitudAmpliacionSsoModel>();

  checkTodosAprobados: boolean = false;
  checkTodosObservados: boolean = false;
  
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    private storage: StorageService,
    public dialog: MatDialog,
    private sedeService: SedeService,
    private parametroService: ParametroService,
    private service: SolicitudAmpliacionSsoService) {
      let usuario = this.storage.getCurrentUser();
      this.listaCompanias = usuario.companias;
      this.model.idCompania = usuario.companiaDefault.idCompania;
     }

  ngOnInit(): void {
    this.companiaChanged();
      this.parametroService
        .getDetalles(ParametrosMaestro.TIPO_SOLICITUD_AMPLIACION)
        .subscribe((p) => {
          this.listaTipos = p.items;
        });
    this.search();
  }

  companiaChanged() {

    this.listaSedes = [];
    this.model.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.model.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }
  
  getPaginatorData(event: any) {
    this.model.page = event.pageIndex + 1;
    this.model.pageSize = event.pageSize;
    // this.serviceSede
    //   .getListFiltered(this.filter)
    //   .subscribe((data) => {
    //     this.model = data;
    //     this.resultsLength = data.total;
    //   });
  }
  openDialogAprobacion(): void {
    let resultados = new SolicitudesAmpliacionAprobacionModel();
    
    resultados.listaSolicitudes = this.listaSolicitudes.filter(p => p.aprobado || p.desaprobado).map((p) => {
      let resultado = new SolicitudAmpliacionAprobacionModel();
      resultado.aprobado = p.aprobado;
      resultado.desaprobado = p.desaprobado;
      resultado.idSolicitudAmpliacionSso = p.idSolicitudAmpliacionSso;
      return resultado;
    });

    const dialogRef = this.dialog.open(SsoAmpliacionAprobacionDialogComponent, {
      width: '700px',
      // data: { name: this.name, animal: this.animal}
      data: resultados
    });    

    dialogRef.afterClosed().subscribe(result => {
      this.search();
    });
  }

  search() {
    //this.paginator.pageIndex = 0;
    this.model.page = 1;
    this.model.pageSize = 30;
    this.service
      .getListPendientes(this.model)
      .subscribe((data: SearchResultModel<SolicitudAmpliacionSsoModel[]>) => {
        this.listaSolicitudes = data.items;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
        // this.resultsLength = data.total;
        // this.currentPage = 0;
        //this.paginator.firstPage();
      });
  }

  export() {
    //this.paginator.pageIndex = 0;
    this.model.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.service
      .exportPendientesList(this.model)
      .subscribe(data => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob:any = data.body;// new Blob([data.body], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        
        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `solicitudes-ampliacion-sso-${Date.now()}.xlsx`);

      //  this.createImageFromBlob(data);
      //  this.isImageLoading = false;
     }, error => {
      //  this.isImageLoading = false;
      //  console.log(error);
     });
  }

  
  esInvalido(): boolean{
    return this.listaSolicitudes.filter(p => p.aprobado || p.desaprobado).length == 0;
  }

  changeAprobado(element: ISolicitudAmpliacionAprobacionModel){    
    if(element.aprobado)
      element.desaprobado = false;
  }

  changeDesaprobado(element: ISolicitudAmpliacionAprobacionModel){    
    // element.aprobado = !element.observado;
    if(element.desaprobado)
      element.aprobado = false;
  }

  changeAprobadoAll(item: any){    
    console.log(item);    
    if(item.checked){
      this.checkTodosObservados = false;
      this.listaSolicitudes.forEach(element => {        
        element.desaprobado = false 
        element.aprobado = item.checked;
      });
    }
    else {
      this.listaSolicitudes.forEach(element => {
        element.aprobado = item.checked;
      });
    }
  }

  changeDesaprobadoAll(item: any){    
    console.log(item);
    
    if(item.checked){
      this.checkTodosAprobados = false;
      this.listaSolicitudes.forEach(element => {
        element.aprobado = false;
        element.desaprobado = item.checked;         
      });
    }
    else {
      this.listaSolicitudes.forEach(element => {
        element.desaprobado = item.checked;         
      });
    }
  }
}
